<template> <!-- OK -->
  <div class="player-management">
    <h2>Gerenciamento das Penalidades</h2>
    <div>
      <button @click="goBack" class="back-button">Voltar para Administração</button>
      <button
          @click="confirmPenalizar"
          class="penalizar-button"
          :disabled="todasPenalidadesAplicadas"
      >
        Penalizar
      </button>
    </div>
    <div class="filter-container">
      <label for="stage">Etapa:</label>
      <select v-model="selectedStageId" @change="fetchPlayers" id="stage">
        <option v-for="stage in stages" :key="stage.id" :value="stage.id">
          {{ stage.name }}
        </option>
      </select>
      <label>Penalidades aplicadas: {{ penalidadesAplicadas }}/3</label>
      <label v-if="!todasPenalidadesAplicadas">
        Próxima penalidade: {{ proximaPenalidadeTexto }}
      </label>
      <label v-else>
        Todas as penalidades foram aplicadas
      </label>
    </div>
    <div class="table-wrapper">
      <table class="player-table">
        <thead>
        <tr>
          <th>Nome</th>
          <th>Jogos Realizados</th>
          <th>Jogos Necessários</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="player in sortedPlayers" :key="player.playerId">
          <td
              :class="{
            'highlight-green' :
             !todasPenalidadesAplicadas &&
             player.playedGames >= jogosNecessariosPara(player),

             'highlight-red':
             !todasPenalidadesAplicadas &&
             player.playedGames < jogosNecessariosPara(player)
          }"
          >
            {{ player.fullName }}
          </td>
          <td>{{ player.playedGames }}</td>
          <td>
            {{ todasPenalidadesAplicadas ? '-' : jogosNecessariosPara(player) }}
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div v-if="showModal" class="modal">
      <div class="modal-content">
        <p>{{ modalMessage }}</p>
        <div class="btn-model">
          <button @click="confirmAction" class="confirm-button">Confirmar</button>
          <button @click="cancelAction" class="cancel-button">Cancelar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import playerService from '../services/playerService';
import stageService from '../services/stageService';

export default {
  name: 'PenalidadesManagement',
  data() {
    return {
      players: [],
      stages: [],
      penalizados: [],
      selectedStageId: null,
      gamesByPlayer: {},
      showModal: false,
      modalMessage: '',
      actionToConfirm: null,
    };
  },
  computed: {
    sortedPlayers() {
      return this.players.slice().sort((a,b) => {
        return a.fullName.localeCompare(b.fullName);
      });
    },
    selectedStage() {
      return this.stages.find(
          stage => Number(stage.id) === Number(this.selectedStageId)
      ) || null;
    },
    penalidadesAplicadas() {
      return this.selectedStage?.penalidadesAplicadas ?? 0;
    },

    todasPenalidadesAplicadas() {
      return this.penalidadesAplicadas >= 3;
    },

    proximaPenalidadeTexto(){
      switch (this.penalidadesAplicadas) {
        case 0:
          return 'Mínimo de 2 jogos';

        case 1:
          return 'Mínimo de 4 jogos';

        case 2:
          return 'Todos os jogos do grupo';

        default:
          return '';
      }
    }
  },
  methods: {
    async fetchStages() {
      try {
        const response = await stageService.getAllStages();
        this.stages = response.data;
        if (this.stages.length > 0) {
          this.selectedStageId = this.stages[this.stages.length - 1].id;
        }
      } catch (error) {
        console.error('Erro ao buscar etapas', error);
      }
    },
    async fetchPlayers() {

      try{
        const response = await playerService.getPlayersWithPlayedGames(this.selectedStageId);
        this.players = response.data;
      } catch (error) {
        console.error('Erro ao buscar jogos dos jogadores', error);
      }

    },
    goBack() {
      this.$router.push('/admin');
    },
    confirmPenalizar() {
      if (!this.selectedStage) return;

      if (this.todasPenalidadesAplicadas){
        alert('Todas as penalidades desta etapa já foram aplicadas.');
        return;
      }

      this.showModal = true;

      if (this.penalidadesAplicadas === 0) {
        this.modalMessage =
            'Tem certeza que deseja aplicar a primeira penalidade? ' +
            'Jogadores com menos de 2 jogos perderão 1 set.';
      }

      if (this.penalidadesAplicadas === 1) {
        this.modalMessage =
            'Tem certeza que deseja aplicar a segunda penalidade? ' +
            'Jogadores com menos de 4 jogos perderão 1 set.';
      }

      if (this.penalidadesAplicadas === 2) {
        this.modalMessage =
            'Tem certeza que deseja aplicar a terceira penalidade? ' +
            'Jogadores que não realizaram todos os jogos do seu grupo perderão 1 set.';
      }

      this.actionToConfirm = this.penalizar;

    },
    async penalizar() {
      if (this.todasPenalidadesAplicadas) {
        throw new Error('Todas as penalidades já foram aplicadas.');
      }

      this.penalizados = [];

      for (const player of this.players) {
        const jogosNecessarios = this.jogosNecessariosPara(player);

        if(player.playedGames < jogosNecessarios){
          this.penalizados.push(player.playerId);
        }
      }

      if (this.penalizados.length > 0) {
        await playerService.applyPenalty(this.penalizados);
      }

      await stageService.updatePenalidade(this.selectedStageId);

      await this.fetchStages();
      await this.fetchPlayers();
    },
    async confirmAction() {
      if (!this.actionToConfirm) return;

      try {
        await this.actionToConfirm();

        alert("Penalidade processada com sucesso!");
        this.showModal = false;
        this.actionToConfirm = null;
      } catch (error) {
        console.error("Erro ao aplicar penalidade:", error);
        alert('Erro ao aplicar penalidade');
      }
    },
    cancelAction() {
      this.showModal = false;
      this.actionToConfirm = null;
    },

    jogosNecessariosPara(player){
      switch (this.penalidadesAplicadas){
        case 0:
          return 2;

        case 1:
          return 4;

        case 2:
          return player.totalGroupGames;

        default:
          return null;
      }
    },
  },
  async created() {
    await this.fetchStages();
    await this.fetchPlayers();
  }
};
</script>

<style scoped>
.player-management {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background-color: #F0F4F7;
  padding: 2rem;
}

.player-management h2 {
  margin-bottom: 2rem;
  color: #003366;
  font-size: 2.5rem;
}

.back-button {
  text-decoration: none;
  color: white;
  background-color: #0056B3;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  font-size: 1rem;
  transition: background-color 0.3s;
  margin-bottom: 1rem;
  margin-right: 1rem;
}

.back-button:hover {
  background-color: #003366;
}

.penalizar-button{
  text-decoration: none;
  color: white;
  background-color: #b30015;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  font-size: 1rem;
  transition: background-color 0.3s;
  margin-bottom: 1rem;
}

.penalizar-button:hover {
  background-color: #81020e;
}

.highlight-green {
  color: green;
  font-weight: bold;
}

.highlight-red {
  color: red;
  font-weight: bold;
}

.filter-container {
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  gap: 1rem;
}

.table-wrapper {
  width: 100%;
  overflow-x: auto;
}

.player-table {
  width: 100%;
  max-width: 1200px;
  border-collapse: collapse;
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.player-table th,
.player-table td {
  padding: 1rem;
  text-align: left;
  border-bottom: 1px solid #DDD;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content {
  background-color: white;
  padding: 2rem;
  border-radius: 8px;
  text-align: center;
}

.confirm-button {
  background-color: #28a745;
  color: white;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}

.confirm-button:hover {
  background-color: #218838;
}

.cancel-button {
  background-color: #e74c3c;
  color: white;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}

.cancel-button:hover {
  background-color: #c0392b;
}

.btn-model{
  margin-top: 1rem;
}


@media (max-width: 768px) {
  .player-management h2 {
    font-size: 2rem;
  }

  .player-table th,
  .player-table td {
    padding: 0.5rem;
    font-size: 0.9rem;
  }

  .back-button {
    font-size: 0.9rem;
    padding: 0.4rem 0.8rem;
  }

}

@media (max-width: 425px) {
  .player-management h2 {
    font-size: 1.5rem;
    text-align: center;
  }

  .player-table th,
  .player-table td {
    padding: 0.3rem;
    font-size: 0.8rem;
  }

  .back-button {
    font-size: 0.8rem;
    padding: 0.3rem 0.6rem;
  }

}
</style>
